<template>
  <div class="com-table balance border">
    <div class="com-title pr">资源报表</div>
    <div class="ms-list">

      <div ref="msSearch"><ms-search :data="search.list" @click="updateConditions"/></div>
      <el-table
        v-loading="table.loading"
        size="small" stripe border
        :data="this.table.list"
        :fit="true">
        <template slot="empty">
          <no-data></no-data>
        </template>

        <el-table-column prop="itemTitle" label="项目名称" min-width="120"></el-table-column>
        <el-table-column prop="dateTime" label="日期" min-width="120"></el-table-column>
        <el-table-column prop="countNum" label="资源获得量(条)" min-width="80"></el-table-column>

      </el-table>
      <el-pagination
        class="pagination"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="table.pagination.page"
        :total="table.pagination.totalRow"
        :page-size="table.pagination.pageSize"
        :page-sizes="table.pagination.pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
      <el-dialog
        title="修改"
        :visible.sync="dialogVisible"
        width="30%"
        top="15%"
        center
        :before-close="handleClose">
        <el-input
          type="textarea"
          :rows="10"
          v-model="message.remark"
          placeholder="请输入内容">
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="modifierRemrak(message.platform)">提 交</el-button>
        </span>
      </el-dialog>
    </div>
  </div>

</template>

<script>
  import MsDetailShow from '@/components/common/FeedbackList'
  import MsSearch from '@/components/common/Search.vue'
  import MsConfirmButton from '@/components/common/ConfirmButton.vue'
  import Api from '@/api/client/cpc-resource-count'
  import ResponseParse from '@/utils/response-parse'
  import { FORM_LIST_SEARCH_CONDITION } from '@/models/resource-count'
  import moment from 'moment'

  export default {
    components: {
      MsDetailShow,
      MsSearch,
      MsConfirmButton
    },
    created () {
      let time = []
      time[0] = moment().format('YYYY-MM-01')
      time[1] = moment().format('YYYY-MM-DD')
      this.search.condition.startTime = time[0]
      this.search.condition.endTime = time[1]
      this.table.list = []
      this.search.list = FORM_LIST_SEARCH_CONDITION
      this.search.list[0].value = time
      Api.itemTitle({search: {modeType: 1}}, response => {
        let itemTitle = response.data.data
        let title = []
        itemTitle.forEach(value => {
          title.push({value: value.id, label: value.title})
        })
        this.search.list[1].config.list = title
      })
      this.requestList()
    },
    data () {
      return {
        dialogVisible: false,
        search: {
          list: [],
          condition: {}
        },
        table: {
          loading: true,
          list: [],
          pagination: {}
        },
        message: {
          index: 0,
          id: 0,
          platform: '',
          remark: ''
        }
      }
    },
    methods: {
      requestList () {
        this.table.loading = true
        const search = Object.assign({}, this.table.pagination, this.search.condition)
        Api.list({search: search}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.table.list = body
            let list = []
            this.table.list.forEach(item => {
              if (item.data !== undefined) {
                let d = JSON.parse(item.data)
                if (d !== null) {
                  item.datas = d
                } else {
                  item.datas = []
                }
              } else {
                item.datas = []
              }
              list.push(item)
            })
            this.table.list = list
            this.table.pagination = ResponseParse.pagination(response.headers)
          } else {
            this.table.list = []
          }
          this.table.loading = false
        })
      },
      handleSizeChange (val) {
        this.table.pagination.pageSize = val
        this.requestList()
      },
      handleCurrentChange (val) {
        this.table.pagination.page = val
        this.requestList()
      },
      updateConditions (conditions) {
        this.table.pagination.page = 1
        let time = conditions.time || []
        this.search.condition = Object.assign({}, conditions, {startTime: time[0], endTime: time[1]})
        this.requestList()
      }
    }
  }
</script>
<style lang="scss" scoped>
  .ms-list{
    position: relative;
    .operation{
      position: absolute;
      top:13px;
      right: 0px;
      z-index: 99;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/client/CpcDailyStatement.vue